<template >
  <v-app>
    <div>
      <h3 style="margin:0px;font-size:20px;">
        {{$t('Stall')}}
        <button
          style="width:100px;height:29px;padding:5px;float:right;background-color:#1976d2;color:white;font-size:14px;border-radius:5px;"
          @click="addStall('new',0)"
        >{{$t('Add')}}</button>
      </h3>
    </div>

    <div style="text-align: center;">
      <h3
        v-if="errorList != ''"
        style="font-size:14px;"
        class="txtClrRed"
      >{{$t('Error')}}: {{errorList}}</h3>
    </div>

    <!-- table -->
    <!-- <div v-if="stallInfo.length==0">
      <br />
      <h3 style="font-size:25px;color:#1976d2;">No stalls found, add a stall?</h3>
    </div>-->
    <v-card>
      <table class="tableList">
        <thead>
          <tr>
            <th class="text-left">{{$t('Code')}}</th>
            <th class="text-left">{{$t('Name')}}</th>
            <th class="text-left">{{$t('Open')}}</th>
            <th class="text-left">{{$t('Active')}}</th>
            <th class="text-left">{{$t('Edit')}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(stall,i) in stallInfo" :key="stall.name">
            <td>{{ stall.qz }}</td>
            <td>{{ stall.ra }}</td>
            <td>
              <v-checkbox
                v-model="stall.rb"
                style="color:black;margin: 0px;"
                color="primary"
                readonly
              ></v-checkbox>
            </td>
            <td>
              <v-checkbox v-model="stall.rc" style="color:black;margin: 0px;" color="primary"></v-checkbox>
            </td>
            <td style="padding:0px;">
              <!-- <v-btn color="primary" class="stallTableButton" @click="addStall('edit',i)">Edit</v-btn> -->
              <v-icon @click="addStall('edit',i)">edit</v-icon>
            </td>
          </tr>
        </tbody>
      </table>
    </v-card>

    <!-- Dialog -->
    <v-layout class="text-xs-center">
      <v-dialog v-model="addStallDialog" persistent width="400">
        <v-card>
          <v-card-title
            class="headline lighten-2"
            style="padding-bottom: 0px;padding-top: 0px;background-color:#1976d2;color:white;"
          >
            <span v-if="newOrEdit == 'new'">{{$t('NewStall')}}</span>
            <span v-if="newOrEdit == 'edit'">{{$t('EditStall')}}</span>
          </v-card-title>
          <v-card-text style="padding:5px;padding-bottom:0px;">
            <v-container grid-list-md style="padding-top: 3px;padding-bottom: 0px;">
              <v-layout wrap>
                <!-- //Code -->
                <v-flex xs3>
                  <h4 class="userProfileTxt">{{$t('Code')}}:</h4>
                </v-flex>
                <v-flex xs9>
                  <input
                    v-model="stallCode"
                    class="form-control"
                    required
                    autocomplete="nope"
                    type="text"
                    name="stallCode"
                    @input="stallCode = $event.target.value"
                  />
                </v-flex>

                <!-- //Name -->
                <v-flex xs3>
                  <h4 class="userProfileTxt">{{$t('Name')}}:</h4>
                </v-flex>
                <v-flex xs9>
                  <input
                    v-model="stallName"
                    class="form-control"
                    required
                    autocomplete="nope"
                    type="text"
                    name="stallName"
                    @input="stallName = $event.target.value"
                  />
                </v-flex>

                <!-- //CheckBox Open -->
                <v-flex xs6>
                  <v-checkbox
                    v-model="cOpen"
                    style="color:black;margin: 0px;"
                    color="primary"
                    :label="$t('Open')"
                  ></v-checkbox>
                </v-flex>

                <!-- //CheckBox Active -->
                <v-flex xs6>
                  <v-checkbox
                    v-model="cActive"
                    style="color:black;margin: 0px;"
                    color="primary"
                    :label="$t('Active')"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
            <span
              v-if="errorAddEditWithTran != ''"
              style="padding:16px;font-size:14px;"
              class="txtClrRed"
            >{{ ''+$t(errorAddEditWithTran)+''}}</span>
            <span
              v-if="errorAddEdit != ''"
              style="padding:16px;font-size:14px;"
              class="txtClrRed"
            >{{errorAddEdit}}</span>
          </v-card-text>
          <v-card-actions style="padding:0px;">
            <v-spacer></v-spacer>
            <v-btn color="default" flat @click="addStallDialog = false">{{$t('Cancel')}}</v-btn>
            <v-btn color="primary" flat @click="saveStallInfo()">{{$t('Save')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <VersionDialog v-if="versionError"></VersionDialog>
  </v-app>
</template>

<script>
import { translateErrorMsg } from './translateErrorMsg'
import VersionDialog from '../src/VersionNotMatchDialog'
import JS from './JsonService'
export default {
  components: {
    VersionDialog
  },
  mixins: [translateErrorMsg],
  data() {
    return {
      errorList: '',
      stallInfo: [],
      addStallDialog: false,
      newOrEdit: '',
      stallId: 0,
      stallCode: '',
      stallName: '',
      cOpen: false,
      cActive: false,
      found: false,
      foundID: 0,
      errorAddEdit: '',
      errorAddEditWithTran: '',
      versionError: false
    }
  },
  created: function() {
    let mchCode = sessionStorage.getItem('backendMchCode')
    //console.log(mchCode)

    this.versionError = false
    var version = sessionStorage.getItem('version')
    const url = 'Back/GetKtnList'
    const parameter = {
      av: version,
      kp: mchCode
    }

    JS.request(url, parameter)
      .then(response => {
        console.log(response.data)
        if (
          response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
          response.data == 'Version Not Match'
        ) {
          this.versionError = true
        } else {
          this.versionError = false
          if (response.data.ListOfKtn) {
            this.errorList = ''
            this.stallInfo = response.data.ListOfKtn
          } else {
            this.errorList = response.data
          }
        }
      })
      .catch(error => {
        //console.log(error)
        this.errorList = error
        this.versionError = false
      })
  },
  destroyed() {
    console.log('destroy')
  },
  methods: {
    addStall(mode, index) {
      console.log(index)
      this.addStallDialog = true
      this.errorAddEdit = ''
      this.errorAddEditWithTran = ''
      this.newOrEdit = mode
      if (this.newOrEdit == 'edit') {
        this.stallId = this.stallInfo[index].rd
        this.stallCode = this.stallInfo[index].qz
        this.stallName = this.stallInfo[index].ra
        this.cOpen = this.stallInfo[index].rb
        this.cActive = this.stallInfo[index].rc
      } else {
        this.stallId = 0
        this.stallCode = ''
        this.stallName = ''
        this.cOpen = false
        this.cActive = true
      }
    },
    saveStallInfo() {
      this.errorAddEditWithTran = ''
      this.errorAddEdit = ''
      if (this.stallCode.trim() == '' || this.stallCode.trim() == undefined) {
        this.errorAddEditWithTran = translateErrorMsg.translateMsg(
          'Stall Code cannot be empty'
        )
      } else if (
        this.stallName.trim() == '' ||
        this.stallName.trim() == undefined
      ) {
        this.errorAddEditWithTran = translateErrorMsg.translateMsg(
          'Stall Name cannot be empty'
        )
      } else {
        let mchCode = sessionStorage.getItem('backendMchCode')

        this.versionError = false
        var version = sessionStorage.getItem('version')
        const url = 'Back/AddEditKtn'
        const parameter = {
          av: version,
          kp: mchCode,
          rd: this.stallId,
          qz: this.stallCode,
          ra: this.stallName,
          rb: this.cOpen,
          rc: this.cActive
        }
        console.log(parameter)

        JS.request(url, parameter)
          .then(response => {
            console.log(response.data)
            if (
              response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
              response.data == 'Version Not Match'
            ) {
              this.versionError = true
            } else {
              this.versionError = false
              if (response.data[0].rd) {
                this.errorAddEdit = ''
                this.errorAddEditWithTran = ''

                this.found = false
                this.foundID = 0
                for (let i = 0; i < this.stallInfo.length; i++) {
                  if (this.stallInfo[i].rd == response.data[0].rd) {
                    this.found = true
                    this.foundID = i
                    break
                  }
                }
                console.log(this.found)
                console.log(this.foundID)
                if (this.found) {
                  this.stallInfo[this.foundID].rd = response.data[0].rd
                  this.stallInfo[this.foundID].qz = response.data[0].qz
                  this.stallInfo[this.foundID].ra = response.data[0].ra
                  this.stallInfo[this.foundID].rb = response.data[0].rb
                  this.stallInfo[this.foundID].rc = response.data[0].rc
                } else {
                  const newStallInfo = []
                  newStallInfo.rd = response.data[0].rd
                  newStallInfo.qz = response.data[0].qz
                  newStallInfo.ra = response.data[0].ra
                  newStallInfo.rb = response.data[0].rb
                  newStallInfo.rc = response.data[0].rc
                  this.stallInfo.push(newStallInfo)
                }

                this.addStallDialog = false
              } else {
                if (
                  response.data ==
                    '@#=#@@=$#1@=$#@#=#@@=$#18@=$#Name Already In Used@=$#0@=$#0' ||
                  response.data == 'Name Already In Used'
                ) {
                  this.errorAddEditWithTran = translateErrorMsg.translateMsg(
                    'Name Already In Used'
                  )
                } else {
                  this.errorAddEditWithTran = ''
                  this.errorAddEdit = response.data
                }
              }
            }
          })
          .catch(error => {
            //console.log(error)
            this.versionError = false
            this.errorAddEdit = error
          })
      }
    }
  }
}
</script>

<style>
.tableList {
  width: 100%;
}
.tableList table,
.tableList th,
.tableList td {
  border-bottom: 1px solid gray;
  border-collapse: collapse;
  padding: 5px;
}

.stallTableButton {
  height: 30px !important;
}

.stallTableButton :hover {
  background-color: #1976d2;
}
</style>
